<p-multiSelect class="w-100 w-md-50"
  [options]="dropdownOptions"
  [placeholder]="placeholder"
  [(ngModel)]="selectedDropdownOptions"
  optionLabel="name"
  (onChange)="onChangeSelection()"
  [filter]="filter"
  [display]="display"
  [maxSelectedLabels]="6"
></p-multiSelect>
